import { useBreadcrumb } from "features/breadcrumbs";
import { Box } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import useListagemAssembleiaColumns from "./hooks/useListagemAssembleiaColumns";
import useAssembleias from "features/assembleia/hooks/useAssembleias";
import Sidebar from "components/Page/Sidebar";
import home1Svg from "assets/images/svgs/home1.svg";
import history from "infra/helpers/history";
import { VotacaoItem } from "features/assembleia/typings";
import NewTable from "components/NewTable";
import { useState } from "react";
import PageHeader from "components/Page/PageHeader";
import OutlineButton from "components/Button/OutlineButton";
import { TabsDetalheAssembleiaRoutes } from "../Detalhes/typings";
import { Flex } from "@chakra-ui/react";
import ModalParametrosAssembleia from "./components/ModalParametrosAssembleia";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { useWindowSize } from "infra/helpers/window";
import { checkPermission } from "infra/helpers/permission";
import Container from "components/Container";
import { BiCog } from "react-icons/bi";

function AssembleiaListagemPage() {
  const [page, setPage] = useState<number>(1);
  const { data, isLoading, refetch } = useAssembleias({ page });
  const [openModalParametros, handleOpenModalParametros] =
    useState<boolean>(false);

  useBreadcrumb([{ name: "Votações" }]);

  const columns = useListagemAssembleiaColumns({
    onToogled: () => {
      refetch();
    },
  });

  const windowSize = useWindowSize();

  const isMobile = windowSize.width <= 768;
  return (
    <Container>
      {openModalParametros ? (
        <ModalParametrosAssembleia
          open={openModalParametros}
          onClose={() => {
            handleOpenModalParametros(false);
          }}
        />
      ) : null}
      <Flex
        justifyContent="space-between"
        flexDirection={!isMobile ? "row" : "column"}
      >
        <PageHeader
          title="Votações"
          titleButton="Adicionar nova votação"
          onClick={() => history.push("/administracao/assembleias/criar")}
          permissions={[PermissaoEnum.Backoffice.Administrativo.Votacao.Criar]}
          justifyContent={!isMobile ? "flex-start" : "space-between"}
        />

        <OutlineButton
          size="sm"
          fontSize={12}
          type="button"
          onClick={() => handleOpenModalParametros(true)}
          style={{ zIndex: 2 }}
          w={!isMobile ? "" : "50%"}
        >
          <BiCog />
          Parâmetros
        </OutlineButton>
      </Flex>

      <Row gutter={32}>
        <Col sm={18}>{/* <DashboardAssembleia mb="40px" /> */}</Col>

        <Col sm={6}>
          <Flex display={!isMobile ? "flex" : "none"}>
            <Sidebar img={home1Svg} />
          </Flex>
        </Col>
      </Row>

      <Box mt="-24px">
        <NewTable<VotacaoItem>
          loading={isLoading}
          columns={columns}
          dataSource={data?.items ?? []}
          customPagination={{
            currentPage: data?.meta.currentPage ?? 0,
            itemsPerPage: data?.meta.itemsPerPage ?? 0,
            totalItems: data?.meta.totalItems ?? 0,
            onChangePage: (p) => setPage(p),
          }}
          onRow={(item) => ({
            onClick: () => {
              if (
                checkPermission(
                  PermissaoEnum.Backoffice.Administrativo.Votacao.Editar,
                  true
                )
              ) {
                history.push(`/administracao/assembleias/${item.id}`);
              }
            },
          })}
          actions={[
            {
              title: "Editar",
              permission:
                PermissaoEnum.Backoffice.Administrativo.Votacao.Editar,
              onClick: (item) =>
                history.push(`/administracao/assembleias/${item.id}`),
            },
            {
              title: "Participantes",
              permission:
                PermissaoEnum.Backoffice.Administrativo.Votacao.Editar,
              onClick: (item) =>
                history.push(
                  `/administracao/assembleias/${item.id}?opcao=${TabsDetalheAssembleiaRoutes.Participantes}`
                ),
            },
            {
              title: "Procurações",
              permission:
                PermissaoEnum.Backoffice.Administrativo.Votacao.Editar,
              onClick: (item) =>
                history.push(
                  `/administracao/assembleias/${item.id}?opcao=${TabsDetalheAssembleiaRoutes.Procuracoes}`
                ),
            },
            {
              title: "Resultado",
              permission:
                PermissaoEnum.Backoffice.Administrativo.Votacao.Resultado,
              onClick: (item) =>
                history.push(
                  `/administracao/assembleias/${item.id}?opcao=${TabsDetalheAssembleiaRoutes.Resultado}`
                ),
            },
            // {
            //   title: "Relatório",
            //   permission:
            //     PermissaoEnum.Backoffice.Administrativo.Votacao.Editar,
            //   onClick: (item) =>
            //     history.push(
            //       `/administracao/assembleias/${item.id}?opcao=${TabsDetalheAssembleiaRoutes.Relatorio}`
            //     ),
            // },
          ]}
        />
      </Box>
    </Container>
  );
}

export default AssembleiaListagemPage;
